import './portfolioEvaluation.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useCallback, useEffect, useState } from 'react';
import { getAllDetails, getAllSymbols, getChartValues } from '../../api/otherEndPoints/portfolioEvaluation';
import { MultiSelect } from 'primereact/multiselect';
import moment from 'moment';
import CustomDateRange from '../customDateRange/CustomDateRange';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import jsPDF from 'jspdf';
import ImageExport from '../base64_images/feedsense_image';
import csvDownload from 'json-to-csv-export';
import { generaliseExportCSV, portFolioCriticalMetricMapping, portFolioCriticalMetricMappingTableHeader } from '../../services/util/util';
import GeneralisePreviewTable from '../adviceStatus/GeneralisePreviewTable';
import { useParams } from 'react-router-dom';

const PortFolioEvaluation = ({ }: any) => {
    const { type }:any = useParams();

    const [chartData, setChartData] = useState<any>([])
    const [currdata, setCurrdata] = useState<any>([])
    const [gridA, setGridA] = useState<any>()
    const [gridB, setGridB] = useState<any>()
    const [gridC, setGridC] = useState<any>()
    const [symbolsOptions, setSymbolsOptions] = useState<any>([]);
    const [drpValue, setDrpValue] = useState<any[]>(symbolsOptions?.[0])
    const [selectedPortfolioSymbol, setSelectedPortfolioSymbol] = useState<string[]>(symbolsOptions);
    const [startPortfolioDate, setStartPortfolioDate] = useState<any>('2019-04-09');
    const [endPortfolioDate, setEndPortfolioDate] = useState<any>(moment().format("YYYY-MM-DD"));
    const [exportData, setExportData] = useState<any>();

    //-------------------CSV PREVIEW-------------//
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [selectedPreviewTableData, setSelectedPreviewTableData] = useState<any[]>([]);
    const [selectedPreviewTableColumns, setSelectedPreviewTableColumns] = useState<any[]>([]);
    const [selectedPreviewTableColumnMapping, setSelectedPreviewTableColumnMapping] = useState<any>({});
    const [selectedFileName, setSelectedFileName] = useState<string>("");

    const memorizedExportCSV = useCallback(generaliseExportCSV,[isModalOpen,selectedPreviewTableData]);
    // const onDownload = useCallback(() => memorizedExportCSV(selectedPreviewTableData,selectedPreviewTableColumnMapping,"MonthlyReturns.csv"), [memorizedExportCSV,selectedPreviewTableData]);
    
    const colOptionsB = [
        { name : 'CALMER RATIO', value : 'calmer_ratio'},
        { name : 'MAR', value : 'mar'},
        { name : 'STERLING RATIO', value : 'sterling_ratio'},
        { name : 'ULCER INDEX', value : 'ulcer_index'}
    ]

    const colOptionsC = [
        { name : 'KAPPA RATIO', value : 'kappa_ratio'},
        { name : 'OMEGA RATIO', value : 'omega_ratio'},
        { name : 'TREYNOR RATIO', value : 'treynor_ratio'},
        { name : 'DEFLATED SHARPE RATIO', value : 'deflated_sharpe_ratio'},
        { name : 'MODIFIED SHARPE RATIO', value : 'modified_sharpe_ratio'},
    ]

    const colOptionsD = [
        { name : 'BETA', value : 'beta'},
        { name : 'COV', value : 'cov'},
        { name : 'JENSEN`S APLHA', value : 'jensen_alpha'},
        { name : 'MODIFIED VAR', value : 'm_var'},
        { name : 'SEMI DEVIATION', value : 'semi_deviation'},
        { name : 'TRACKING ERROR', value : 'tracking_error'}
    ]

    const colA = {
        title: {
          text: `${[drpValue]?.map((item:any) => item?.s_symbol)} - Ratio Details`,
        },
        xAxis: {
          categories: chartData.duration,
          labels: {
            rotation: -90,
            steps:1000,
          }
        },
        tooltip: {
          valueDecimals: 2,
        },
        series: [
          {
            name: 'Sharpe Ratio',
            data: chartData.sharpe_ratio,
            color: '#568ccd'
          },
          {
            name: 'Sortino Ratio',
            data: chartData.sortino_ratio,
            color: '#4fc967'
          },
          {
            name: 'Information Ratio',
            data: chartData.information_ratio,
            color: '#06b6d4'
          }
        ],
        chart: {
          height: 600,
          type : 'area',
          borderWidth: -1,
          spacingTop: 25
        },
        credits: { enabled: false },
        accessibility: {
          enabled: false
        },
        plotOptions: {
          series: {
              fillOpacity: 0.1
          },
        },
        legend: {
          align: 'right',
          verticalAlign: 'top',
          x: 0,
          y: 0
      },
      yAxis:{
        gridLineWidth : 0,
        title: {
            text: 'Ratio'
        }
      },
    };

    const colB = {
        title: {
            text: ``
          },
          xAxis: {
            categories: chartData?.duration,
            labels: {
              rotation: -90,
              steps:1000,
            }
          },
          tooltip: {
            valueDecimals: 2,
          },
          series: [
            {
              name: `${gridA}`.toUpperCase().replace('_', ' '),
              data: chartData[gridA],
              color: '#568ccd'

            }
          ],
          chart: {
            height: 600,
            type: 'area',
            borderWidth: -1,
            spacingTop: 25
          },
          credits: { enabled: false },
          accessibility: {
            enabled: false
          },
          plotOptions: {
            series: {
                fillOpacity: 0.1,
                color: '#da7958'
            }
        },
        legend: {
          align: 'right',
          verticalAlign: 'top',
          x: 0,
          y: 0,
        },
        yAxis:{
        gridLineWidth : 0
        }
    };

    const colC = {
        title: {
            text: ``
            },
            xAxis: {
            categories: chartData?.duration,
            labels: {
                rotation: -90,
                steps:1000,
            }
            },
            tooltip: {
            valueDecimals: 2,
            },
            series: [
            {
                name: `${gridB}`.toUpperCase().replace('_', ' '),
                data: chartData[gridB],
                color: '#568ccd'

            }
            ],
            chart: {
            height: 600,
            type: 'area',
            borderWidth: -1,
            spacingTop: 25
            },
            credits: { enabled: false },
            accessibility: {
            enabled: false
            },
            plotOptions: {
            series: {
                fillOpacity: 0.1,
                color: '#da7958'
            }
        },
        legend: {
            align: 'right',
            verticalAlign: 'top',
            x: 0,
            y: 0,
        },
        yAxis:{
        gridLineWidth : 0
        }
    };

    const colD = {
        title: {
            text: ``
          },
          xAxis: {
            categories: chartData?.duration,
            labels: {
              rotation: -90,
              steps:1000,
            }
          },
          tooltip: {
            valueDecimals: 2,
          },
          series: [
            {
              name: `${gridC}`.toUpperCase().replace('_', ' '),
              data: chartData[gridC],
              color: '#568ccd'

            }
          ],
          chart: {
            height: 600,
            type: 'area',
            borderWidth: -1,
            spacingTop: 25
          },
          credits: { enabled: false },
          accessibility: {
            enabled: false
          },
          plotOptions: {
            series: {
                fillOpacity: 0.1,
                color: '#da7958'
            }
        },
        legend: {
          align: 'right',
          verticalAlign: 'top',
          x: 0,
          y: 0,
        },
        yAxis:{
        gridLineWidth : 0
        }
    };

    const tooltipDetails = {
        "sharpeRatio"   : 'The Sharpe Ratio measures the performance of an investment by adjusting for its risk, calculating the excess return per unit of volatility.',

        "beta"          : "Beta measures an asset's sensitivity to market movements, indicating how much the asset's price is expected to change in response to a 1% change in the overall market.",

        "treynorRatio"  : "The Treynor Ratio measures the return of an investment in relation to its market risk (beta), calculating the excess returnper unit of market risk to assess how well an investment compensates forthat specific risk.",

        "jensenAlpha"   : "Jensen's Alpha measures the excess return of aninvestment compared to its expected return, based on its beta and the overall market return, indicating how well the investment has performedrelative to its risk-adjusted benchmark.",

        "trackingError" : "Tracking Error measures the volatility of an asset's returns relative to a benchmark index, indicating how closely the asset's performance matches the benchmark's performance over a specific period.",

        "infoRatio"     : "The Information Ratio measures the risk-adjusted return of an investment relative to a benchmark, calculating the excess return per unit of tracking error, and helps assess how consistently an asset outperforms its benchmark.",

        "mVar"          : "MVAR (Modified Value at Risk) is a risk measure that incorporates not just the standard deviation of returns but also adjustments for the skewness of the return distribution. It aims to provide a more comprehensive assessment of risk compared to traditional measures like Value at Risk (VaR), which often assume normality of returns.",

        "cov"           : "The coefficient of variation allows investors to determine how much volatility, or risk, is assumed in comparison to the amount of return expected from investments. We should choose portfolio which has less coefficient of variation as it offers less risk at a given return.",

        "modSR"         : "The Modified Sharpe Ratio adjusts the classic Sharpe Ratio by incorporating higher moments of the return distribution—specifically, skewness and kurtosis. This enhancement makes it particularly valuable for evaluating assets or portfolios with non-normal return distributions, including those with asymmetry (skewness) or extreme values (heavy tails). A higher Modified Sharpe Ratio implies the portfolio provides better returns for the given level of adjusted risk, making it a preferable choice if you want efficient risk-adjusted growth.",

        "mar_ratio"     : "The MAR ratio (Managed Account Ratio) measures risk-adjusted returns by dividing an investment’s compound annual growth rate (CAGR) by its maximum drawdown. This ratio highlights the balance between return and risk, with a higher MAR indicating stronger returns relative to potential losses. A higher MAR ratio indicates a favorable balance between risk and reward, suggesting that the investment has generated strong returns relative to its worst loss.",

        "sterling_r"    : "The Sterling Ratio is a risk-adjusted performance metric that evaluates an investment's return relative to the severity of its largest drawdown. It calculates the difference between the annualized return and a risk-free rate, divided by the maximum drawdown observed. A higher Sterling Ratio signifies a more favorable risk-return tradeoff, indicating that the investment generates better returns per unit of risk.",

        "semiDev"       : "Semi-deviation  is a risk measure focusing on negative returns below a target or threshold (commonly the mean or zero) making it a measure of downside risk which is important for the risk averse investors.",

        "sortino_r"     : "Sortino Ratio is a measure of risk-adjusted return that focuses only on downside risk i.e it measures how well an investment or portfolio performs relative to the risk of negative returns (downside risk).",

        "ulcerIdx"      : "The Ulcer Index calculates the severity and duration of drawdowns in an asset's price by measuring the percentage loss from the peak value at each point in time. It computes the square root of the average of the squared negative drawdowns, focusing on downside risk. A higher Ulcer Index indicates greater downside risk and a more significant history of price declines.",

        "calmerRatio"   : "Calmar Ratio is a measure of risk-adjustedreturn relative to the risk measured by maximum drawdown i.e it evaluates the performance of an investment by comparing its annualized return to its maximum drawdown, giving insight into how well the investment compensates for the risk of significant losses.",

        "omegaRatio"    : "The Omega ratio is a performance measure that compares the probability-weighted gains to the probability-weighted losses of an investment, helping to assess its risk-adjusted return.",

        "kappaRatio"    : "The Kappa ratio is a financial metric used to assess the proportion of a company's risk-adjusted return relative to its volatility, often used in the context of evaluating investment strategies.",

        "deflatedSR" : "The deflated Sharpe ratio adjusts the traditional Sharpe ratio by accounting for multiple testing bias, non-normal returns, and serial correlation to provide a more realistic measure of risk-adjusted performance."

    }

    const exportPdfColumns = [
        {name: "Symbols", value: "s_symbol"},
        {name: "Sharpe Ratio", value: "n_sharpe_ratio"},
        {name: "Beta", value: "n_beta"},
        {name: "Jensen's Alpha", value: "n_jensen_alpha"},
        {name: "Treynor Ratio", value: "n_treynor_ratio"},
        {name: "Tracking Error", value: "n_tracking_error"},
        {name: "Information Ratio", value: "n_information_ratio"},
        {name: "Deflated Sharpe Ratio", value: "n_deflated_sharpe_ratio"},
        {name: "Co-efficient of Variation", value: "n_cov"},
        {name: "Modified Var", value: "n_modified_var"},
        {name: "Modified Sharpe Ratio", value: "n_modified_sharpe_ratio"},
        {name: "MAR Ratio", value: "n_mar"},
        {name: "Sterling Reserve", value: "n_sterling_ratio"},
        {name: "Semi Deviation", value: "n_semi_deviation"},
        {name: "Sortino Ratio", value: "n_sortino_ratio"},
        {name: "Ulcer Index", value: "n_ulcer_index"},
        {name: "Calmer Ratio", value: "n_calmer_ratio"},
        {name: "Omega Ratio", value: "n_omega_ratio"},
        {name: "Kappa Ratio", value: "n_kappa_ratio"},

    ]

    function addWaterMark(doc: any) {
        var totalPages = doc.internal.getNumberOfPages();  
        for (let i = 1; i <= totalPages; i++) {
          doc.setGState(new doc.GState({opacity: 0.7}));
          doc.setPage(i);
          doc.setFontSize(48)
          doc.setFont('Helvetica', 'bold')
          doc.setTextColor(230,230,230);
          doc.text('FeedSense AI', 160,160, null, 45, 'center');
        }  
        return doc;
    }

    const addFooters = (doc: any) => {
        const pageCount = doc.internal.getNumberOfPages()
        doc.setFont('helvetica', 'italic')
        doc.setTextColor(0,0,0);
        doc.setFontSize(10)
        for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)
        doc.text('Page ' + String(i) + ' of ' + String(pageCount),260,200)
        if(i == pageCount){
            doc.setFont('Helvetica', 'italic')
            doc.text('Disclaimer: We are using statistical and artificial models etc. which are never error-free. Please apply your own discretions while using this information.',10,200)
        }
        }
    }

    const tradesExports = (data: any, value:number) => {
          const tradeDataToConvert = {
            data: currdata,
            filename: `Portfolio Evaluation`,
            delimiter: ",",
            headers: [
              "Stock",
              "Rolling Duration",
              "Sharpe_ratio",
              "Beta",
              "Jensen_alpha",
              "Treynor_ratio",
              "Tracking_error",
              "Information_ratio",
              "Deflated_sharpe_ratio",
              "Co-efficient of Variation",
              "Modified_var",
              "Modified_sharpe_ratio",
              "Mar Ratio",
              "Sterling_ratio",
              "Semi_deviation",
              "Sortino_ratio",
              "Ulcer_index",
              "Calmer_ratio",
              "Omega_ratio",
              "Kappa_ratio"
        
            ],
        }
        csvDownload(tradeDataToConvert);
      
    }
    
    const exportCols = exportPdfColumns.map((exportPdfColumn) => ({ title: exportPdfColumn.name, dataKey: exportPdfColumn.value }));

    const exportPdf = () => {
        var doc = new jsPDF('l');
         var image = ImageExport()
         const imageWidth = 50;
         const imageHeight = 15;
         const pageWidth = doc.internal.pageSize.getWidth();
         const imageX = (pageWidth - imageWidth) / 2;
            doc.setFont('Lato-Regular', 'bold')
            doc.setFontSize(13)
            doc.text('Portfolio Evaluation Of Cash Models', 145, 35, { align: 'center'});
            (doc as any).autoTable(exportCols, currdata, {
              styles: {
                halign: 'left'
            },
            startY: 40,
            margin: { top: 30 },
            didDrawPage: (data: any) => {
              // Draw image in header (every page)
              doc.addImage(image, 'PNG', imageX, 8, imageWidth, imageHeight);
        
              // Horizontal line
              doc.setLineWidth(0.1);
              doc.line(10, 25, pageWidth - 10, 25);
            },
            headStyles : {lineWidth: 0.5,fillColor: [224, 224, 224],textColor: [0,0,0]},
            theme: 'grid',
          }
         );
        doc = addWaterMark(doc)
        addFooters(doc)
        doc.save('FeedSense AI | Portfolio Evaluation.pdf');
    };

  const getAllVal = async () => {
    if (selectedPortfolioSymbol.length > 0) {

      let response = await getAllDetails(selectedPortfolioSymbol, startPortfolioDate, endPortfolioDate, type);
      if (response?.length >= 0) {
        response = response.map((item: any) => ({...item,s_symbol: item.s_symbol?.split('_')[0],}));
        setCurrdata(response);
      }
    }
    else {
      setCurrdata([])
    }
  }

  const getChartDetails = async () => {

    if (drpValue) {
      let response = await getChartValues(drpValue, startPortfolioDate, endPortfolioDate, type)
      if (response) {
        setChartData(response);
        setGridA(colOptionsB[0].value)
        setGridB(colOptionsC[0].value)
        setGridC(colOptionsD[0].value)
      }
    }
  }

  // const getAllSymbolDetails = async () => {
  //   let response = await getAllSymbols(type)
  //   if (response?.length > 0) {
  //     setSymbolsOptions(response);
  //     setSelectedPortfolioSymbol(response);
  //     setDrpValue(response[0]);

  //   }
  // }
  const getAllSymbolDetails = async () => {
    let response = await getAllSymbols(type)        
    if (response?.length > 0 && type !== 'equityN50BANK'){
        setSymbolsOptions(response);  
        setSelectedPortfolioSymbol(response);
        setDrpValue(response[0]);

    }
    else if (response?.length > 0 && type === 'equityN50BANK'){
        let new_symbol = response.map((item: any) => ({...item,s_symbol: item.s_symbol?.split('_')[0],}));
        console.log("THis is the response in porteval",new_symbol);
       
        setSymbolsOptions(new_symbol);  
        setSelectedPortfolioSymbol(response);
        setDrpValue(new_symbol[0]);

    }
}
    
    useEffect(() => {
        getAllSymbolDetails()
    }, [])

    useEffect (() => {
        getAllVal()
    },[selectedPortfolioSymbol, startPortfolioDate, endPortfolioDate])

    useEffect(() => {
        getChartDetails()
    }, [drpValue, startPortfolioDate, endPortfolioDate])
    console.log(selectedPortfolioSymbol)
    return (
        <> 

            <div className='portfolio-filter'>
            <GeneralisePreviewTable
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              columnHeader={selectedPreviewTableColumns}
              tableData={selectedPreviewTableData}
              onDownload={()=>{memorizedExportCSV(selectedPreviewTableData, selectedPreviewTableColumnMapping, selectedFileName)}}
            />
                <MultiSelect  value={selectedPortfolioSymbol} options={symbolsOptions} onChange={(e) => setSelectedPortfolioSymbol(e.value)} placeholder={selectedPortfolioSymbol.length === 25 ? 'All symbols': 'Select symbols'} optionLabel="s_symbol" className='multiselect' maxSelectedLabels={1} />
                &emsp;&emsp;
                <CustomDateRange backStartDate={startPortfolioDate} setBackStartDate={setStartPortfolioDate} backEndDate={endPortfolioDate} setBackEndDate={setEndPortfolioDate} />

                <div className='download-options'>
                  <Button type="button" icon="pi pi-file-pdf" rounded onClick={exportPdf} className='button1' />
                  <Button type="button" icon="pi pi-download" 
                  rounded 
                  onClick={()=>{
                    setSelectedPreviewTableData(currdata);
                    setSelectedPreviewTableColumns(portFolioCriticalMetricMappingTableHeader);
                    setSelectedPreviewTableColumnMapping(portFolioCriticalMetricMapping);
                    setSelectedFileName("Portfolio Evaluation.csv")
                    setIsModalOpen(true);
                
                }}
                  className='button1' />
                </div>
            </div>
            
            <div>
                <DataTable value = { currdata } scrollable resizableColumns stripedRows sortMode="multiple" >

                    <Column 
                    field= "s_symbol"  
                    header= "Symbol" 
                    style={{ minWidth: '100px'}} sortable>
                    </Column> 

                    <Column 
                    headerTooltip={tooltipDetails.sharpeRatio}
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}
                    field= "n_sharpe_ratio"  header= "Sharpe Ratio"
                    >
                    </Column> 

                    <Column field= "n_beta"  
                    header= "Beta" 
                    headerTooltip={tooltipDetails.beta} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>


                    <Column field= "n_jensen_alpha"  
                    header= "Jensen Alpha" 
                    headerTooltip={tooltipDetails.jensenAlpha} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_treynor_ratio"  
                    header= "Treynor Ratio" 
                    headerTooltip={tooltipDetails.treynorRatio} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_tracking_error"  
                    header= "Tracking Error" 
                    headerTooltip={tooltipDetails.trackingError} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_information_ratio"  
                    header= "Information Ratio" 
                    headerTooltip={tooltipDetails.infoRatio} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    {/* <Column field= "n_deflated_sharpe_ratio"  
                    header= "Deflated Sharpe Ratio" 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column> */}
                    <Column field= "n_deflated_sharpe_ratio"  
                    header= "Deflated Sharpe Ratio" 
                    headerTooltip={tooltipDetails.deflatedSR} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_cov"  
                    header= "Co-efficient of Variation" 
                    headerTooltip={tooltipDetails.cov} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_modified_var"  
                    header= "Modified Value At Risk" 
                    headerTooltip={tooltipDetails.mVar} 
                    headerTooltipOptions={{position: "top", }}
                    sortable style={{minWidth: '150px'}}
                    >
                    </Column>

                    <Column field= "n_modified_sharpe_ratio"  
                    header= "Modified Sharpe Ratio" 
                    headerTooltip={tooltipDetails.modSR} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_mar"  
                    header= "MAR Ratio" 
                    headerTooltip={tooltipDetails.mar_ratio} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_sterling_ratio"  
                    header= "Sterling Ratio" 
                    headerTooltip={tooltipDetails.sterling_r} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_semi_deviation"  
                    header= "Semi Deviation" 
                    headerTooltip={tooltipDetails.semiDev} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_sortino_ratio"  
                    header= "Sortino Ratio" 
                    headerTooltip={tooltipDetails.sortino_r} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_ulcer_index"  
                    header= "Ulcer Index" 
                    headerTooltip={tooltipDetails.ulcerIdx} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_calmer_ratio"  
                    header= "Calmer Ratio" 
                    headerTooltip={tooltipDetails.calmerRatio} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_omega_ratio"  
                    header= "Omega Ratio" 
                    headerTooltip={tooltipDetails.omegaRatio} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                    <Column field= "n_kappa_ratio"  
                    header= "Kappa Ratio" 
                    headerTooltip={tooltipDetails.kappaRatio} 
                    headerTooltipOptions={{position: "top"}}
                    sortable style={{minWidth: '150px'}}> 
                    </Column>

                </DataTable>
                
            </div>

            <div className="charts">
                <div className='returnchartCard'>
                    <div className='dropdown'>
                    <Dropdown value={drpValue} onChange={(e) => {setDrpValue(e.target.value) }} options={symbolsOptions} optionLabel="s_symbol" placeholder="Select a Symbol" checkmark={true} highlightOnSelect={false} />
                    &emsp;
                    </div>
                    <div className='returnChart'>  <HighchartsReact highcharts={Highcharts} oneToOne={true} options={colA} /></div>
                </div>
                
                <div className='multicharts_grid'>
                  <div className='symbol-tag'>{[drpValue]?.map((item:any) => item?.s_symbol)}</div>
                    <div className="grid-container">
                        <div>
                            <div className='customproperty'>
                                <div><h5 className='propertyHeaders'></h5></div>
                                <div><Dropdown value={gridA} onChange={(e) => setGridA(e.target.value)} options={colOptionsB} optionLabel="name" placeholder="Select a Property" checkmark={true} highlightOnSelect={false}/></div>
                            </div>
                            <HighchartsReact highcharts={Highcharts} oneToOne={true} options={colB}/>
                        </div>
                        <div>
                            <div className='customproperty'>
                                <div><h5 className='propertyHeaders'></h5></div>
                                <div><Dropdown value={gridB} onChange={(e) => setGridB(e.target.value)} options={colOptionsC} optionLabel="name" placeholder="Select a Property" checkmark={true} highlightOnSelect={false} /></div>
                            </div>
                            <HighchartsReact highcharts={Highcharts} oneToOne={true} options={colC} />
                        </div>
                        <div>
                            <div className='customproperty'>
                                <div><h5 className='propertyHeaders'></h5></div>
                                <div><Dropdown value={gridC} onChange={(e) => setGridC(e.target.value)} options={colOptionsD} optionLabel="name" placeholder="Select a Property" checkmark={true} highlightOnSelect={false} /></div>
                            </div>
                            <HighchartsReact highcharts={Highcharts} oneToOne={true}  options={colD} />
                        </div>
                    </div> 
                </div>       
            </div>
                     
        </> 
    );
};

export default PortFolioEvaluation;